import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "avatar-container__initials primary-background-button-color"
}
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "w-100 d-flex justify-space-between" }
const _hoisted_4 = { class: "font-size-14-600" }
const _hoisted_5 = { class: "font-size-12-400" }

import {computed} from "vue";
import Icon from "@/components/Icons/Icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PractitionerPage',
  props: {
  practitioner: {
    type: Object,
  },
  isPractitionerSelected: {
    type: Boolean,
    default: false,
  },
  borderColor: {
    type: String,
    default: '#F0F0F0',
  },
},
  emits: ['select', 'infoSelected'],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "e8e82b6a": (__props.borderColor)
}))

const emit = __emit;

const props = __props;

const getAvatar = computed(() => {
  const creator = props.practitioner;
  if (creator) {
    const firstName = creator.first_name ?? '';
    const lastName = creator.last_name ?? '';

    return creator.image
        ? {image: creator.image.file?.file_path ?? '', initials: null}
        : {image: null, initials: (firstName[0] + (lastName[0] || '')).toUpperCase()};
  }
  return null;
});

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "card-container pa-4 d-flex align-center ga-4" }, {
    default: _withCtx(() => [
      (getAvatar.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "position-relative",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('infoSelected')))
          }, [
            _createVNode(_component_v_sheet, { class: "avatar-container" }, {
              default: _withCtx(() => [
                (getAvatar.value?.image)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      style: _normalizeStyle({ backgroundImage: `url(${getAvatar.value.image})` }),
                      class: "avatar-container__image"
                    }, null, 4))
                  : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(getAvatar.value?.initials), 1))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(Icon, {
                color: "primaryButtonColor",
                height: "22",
                icon: "info-icon",
                width: "22"
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(__props.practitioner?.first_name) + " " + _toDisplayString(__props.practitioner?.last_name), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(__props.practitioner?.role_legacy), 1)
        ]),
        _createVNode(_component_v_btn, {
          class: _normalizeClass([__props.isPractitionerSelected ? 'secondary-button' : 'transparent secondary-button-color', "b-round-20 outline-btn"]),
          elevation: "0",
          height: "32px",
          variant: "outlined",
          width: "82px",
          "x-small": "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('select')))
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" Select ", -1)
          ]))]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _: 1
  }))
}
}

})